const SUPPORTED_LOCALES = ['en', 'es', 'pt'];

export function detectLocale() {
  if (typeof navigator === 'undefined') {
    return 'en';
  }

  const candidates = [...(navigator.languages || []), navigator.language].filter(
    Boolean,
  );

  for (const language of candidates) {
    const locale = language.toLowerCase().split('-')[0];

    if (locale === 'es') {
      return 'es';
    }

    if (locale === 'pt') {
      return 'pt';
    }

    if (locale === 'en') {
      return 'en';
    }
  }

  return 'en';
}

export function isSupportedLocale(locale) {
  return SUPPORTED_LOCALES.includes(locale);
}
